// extracted by mini-css-extract-plugin
export default {"total":"Table_total__4SDq8"};